// extracted by mini-css-extract-plugin
export default {"container":"HeadshotUpload_container__kUVrb","modalWrapper":"HeadshotUpload_modalWrapper__AHkMH"};